import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { scrollToAnchor } from '../../../util/helpers';

export default function useScrollToAnchor(anchorId: string, enabled = true) {
  const { hash } = useLocation();
  const hasScrolled = useRef(false);

  useEffect(() => {
    hasScrolled.current = false;
  }, [hash, anchorId]);

  useEffect(() => {
    if (!enabled || hasScrolled.current || hash !== `#${anchorId}`) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      const element = document.getElementById(anchorId);
      if (!element) {
        return;
      }

      scrollToAnchor(anchorId);
      hasScrolled.current = true;
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [anchorId, enabled, hash]);
}
